import React from "react";
import PropTypes from "prop-types";
import { Button, IconButton, Badge } from "@toddle-edu/ds-web";
import { ChatOutlined } from "@toddle-edu/ds-icons";
import _ from "lodash";
import classes from "./CommentButton.scss";

const styles = {
  commentButtonStyleV2: {
    padding: "8px",
  },
};

const CommentButton = props => {
  const {
    totalCommentCount,
    unreadCommentCount,
    onCommentClick,
    isCommentActive,
    commentIconSize,
    testId,
    label,
  } = props;

  const ButtonComponent = () => (
    <Button
      type="plain"
      variant="neutral"
      size={commentIconSize}
      icon={<ChatOutlined variant="subtle" />}
      style={styles.commentButtonStyleV2}
      isActivated={isCommentActive}
      onClick={onCommentClick}
      testId={`${testId}-${_.camelCase(label)}-chatIcon`}
    >
      <div className={classes.count}>{totalCommentCount}</div>
    </Button>
  );

  if (totalCommentCount > 0) {
    if (unreadCommentCount > 0) {
      return (
        <Badge placement="topLeft" type="dot" offset={[10, 10]}>
          <ButtonComponent />
        </Badge>
      );
    }
    return <ButtonComponent />;
  }
  return (
    <IconButton
      icon={<ChatOutlined variant="subtle" />}
      size={commentIconSize}
      type="plain"
      variant="neutral"
      isActivated={isCommentActive}
      onClick={onCommentClick}
      testId={`${testId}-${_.camelCase(label)}-chatIcon`}
    />
  );
};

CommentButton.propTypes = {
  totalCommentCount: PropTypes.number,
  unreadCommentCount: PropTypes.number,
  onCommentClick: PropTypes.func,
  isCommentActive: PropTypes.bool,
  commentIconSize: PropTypes.string,
  testId: PropTypes.string,
  label: PropTypes.string,
};

export default CommentButton;
